// reducers.js
//import everything from actions.js

import * as actions from "./actions";

const initialState = {
  teachingType: 0, // Initial state for teachingType
  lastName: "",
  firstName: "", // Initial state for fullName
  dba: "", // Initial state for dba
  organizationName: "", // Initial state for organizationName
  orgCategory: "", // Initial state for orgCategory
  streetAddress: "", // Initial state for streetAdress
  city: "", // Initial state for city
  state: "", // Initial state for state
  zipCode: "", // Initial state for zipCode
  country: "United States", // Initial state for country
  apt: "", // Initial state for apt
  teachingPageUrl: "", // Initial state for teachingPageUrl
  alreadyTeachingOnline: "", // Initial state for alreadyTeachingOnline
  studentsCSV: "", // Initial state for studentsCSV
  paymentPeriod: 0, // Initial state for paymentPeriod
  packageType: 0, // Initial state for packageType
  error: {
    lastName: "",
    firstName: "",
    dba: "",
    organizationName: "",
    orgCategory: "",
    streetAddress: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",
    apt: "",
    teachingPageUrl: "",
    alreadyTeachingOnline: "",
    studentsCSV: "",
    paymentPeriod: "",
    packageType: "",
    teachingType: "",
    addressObj: "",
  },
  addressObj: "",
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    // case actions.SET_FULL_NAME:
    //   return {
    //     ...state,
    //     fullName: action.payload,
    //   };
    case actions.SET_FIRSTNAME:
      return {
        ...state,
        firstName: action.payload,
      };
    case actions.SET_LASTNAME:
      return {
        ...state,
        lastName: action.payload,
      };
    case actions.SET_DBA:
      return {
        ...state,
        dba: action.payload,
      };
    case actions.SET_ORG_FULL_NAME:
      return {
        ...state,
        organizationName: action.payload,
      };
    case actions.SET_ORG_CATEGORY:
      return {
        ...state,
        orgCategory: action.payload,
      };
    case actions.SET_STREET_ADRESS:
      return {
        ...state,
        streetAddress: action.payload,
      };
    case actions.SET_CITY:
      return {
        ...state,
        city: action.payload,
      };
    case actions.SET_STATE:
      return {
        ...state,
        state: action.payload,
      };
    case actions.SET_ZIP_CODE:
      return {
        ...state,
        zipCode: action.payload,
      };
    case actions.SET_COUNTRY:
      return {
        ...state,
        country: action.payload,
      };
    case actions.SET_APT:
      return {
        ...state,
        apt: action.payload,
      };
    case actions.TEACHING_PAGE_URL:
      return {
        ...state,
        teachingPageUrl: action.payload,
      };
    case actions.ALREADY_TEACHING_ONLINE:
      return {
        ...state,
        alreadyTeachingOnline: action.payload,
      };
    case actions.STUDENTS_CSV:
      return {
        ...state,
        studentsCSV: action.payload,
      };
    case actions.PAYMENT_PERIOD:
      return {
        ...state,
        paymentPeriod: action.payload,
      };
    case actions.PACKAGE_TYPE:
      return {
        ...state,
        packageType: action.payload,
      };
    case actions.TEACHING_TYPE:
      return {
        ...state,
        teachingType: action.payload,
      };
    case actions.ADDRESS_TYPE:
      return {
        ...state,
        addressObj: action.payload,
      };
    case actions.ERROR:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default rootReducer;
